
import React from 'react';

import { ExportServerButton2 } from '../../../components/dialogs/OrdersExportDialog/ExportServerButton';


export const ExportArticleButton = (props) => (
	<ExportServerButton2 {...props} endpoint="pricelist-articles" type="xlsx" label="XLSX" sort={["code", "DESC"]} />
);